import { fork, select, take } from 'redux-saga/effects';
import { getDate, getLayout, getSync } from 'selectors/monitoringSelectors';
import { SetZoomAction } from 'actions/monitoringActions';
import { CellIndex } from 'types';
import { redrawTimelineSaga } from './timelinesRedrawSaga';


export function* setZoomWatcher() {
    while (true) {
        // Wait for the user to zoom in/out on a timeline
        const action: SetZoomAction = yield take('SET_ZOOM');
        const { cellIndex } = action.payload;

        // Collect all the cells we need to update -- Start with the specified cell
        const cellsToUpdate = [
            cellIndex,
        ];

        // Does the specified cell have it's zoom synchronization flag set?
        const syncZoom: boolean = yield select(getSync, { cellIndex });

        // If so, find out which other cells have their flag set too
        if (syncZoom) {
            const nCells: number = yield select(getLayout);
            for (let i = 1 as CellIndex; i <= nCells; i++) {
                if (i === cellIndex) continue; // We've already got this one
                
                if (yield select(getSync, { cellIndex: i })) {
                    cellsToUpdate.push(i);
                }
            }
        }

        const utcDate: Date = yield select(getDate);

        // Update all the cells that we just collected
        while (cellsToUpdate.length) {
            const cellIndex = cellsToUpdate.shift() as CellIndex;
            yield fork(redrawTimelineSaga, cellIndex, utcDate);
        }
    }
}



// WEBPACK FOOTER //
// ./src/sagas/monitoring/syncZoomSaga.ts